





























import { Vue, Component, Prop } from "vue-property-decorator";
import CustomContainer from "@/components/Globals/CustomContainer.vue";
import CustomButton from '@/components/Globals/CustomButton.vue';
import CustomText from '@/components/Globals/CustomText.vue';
import ugc from '@/mixins/UGC';
import undo from "@/mixins/Customizer/Undo";
import imageLibrary from '@/mixins/imageLibrary';
import { resolveImageLibraryLabel } from '@/utils/imageLibraryLabel';

const defaultClickOverride = () => {};

@Component({
  components: {
    CustomContainer,
    CustomButton,
		CustomText
  },
	mixins: [ undo, ugc, imageLibrary ]
})
export default class AddYourImageGalleryEdit extends Vue {

	[x: string]: any;

	@Prop({default: defaultClickOverride})
	clickOverride!: Function

	@Prop({default: false})
  disableButton?: boolean

  @Prop({required: false})
  keyTranslation!: string;

  @Prop({required: false})
  textLabel!: string;

  get imageLibraryLabel() {
		const fallbackLabel = this.translations?.trayWrapper?.[this.keyTranslation] || this.textLabel;
		return resolveImageLibraryLabel(this.translations, fallbackLabel);
	}

  get buttonText() {
		const { translations } = this;
		return this.isApparel ? translations.ugcReplace : translations.ugcEdit;
	}

	get translations() {
		return this.$store.state.translations.data;
	}

	get queryParams() {
		return this.$store.state.utils.queryParams;
	}

	get ugcFeature() {
		return this.tempData.features[this.tempData.activeUGCIndex].ugcFeature;
	}

	get shouldUseClickOverride() {
		return this.clickOverride && this.clickOverride !== defaultClickOverride;
	}

	get isMobile() {
		return this.$store.getters["utils/returnScreenSize"].includes('mobile');
	}

	setClickUGC() {
		this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_INDEX", "imageLibrary");
		this.$store.commit('ugc/tempData/SET_ACTIVE_UGC_COMPONENT', this.$store.state.standardNavigation.activeComponent);
		const { activeUGCComponent } = this.tempData;
		this.editImageLibrary();
	}

	edit() {
		this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_INDEX", "imageLibrary");
		this.$store.commit('ugc/tempData/SET_ACTIVE_UGC_COMPONENT', this.$store.state.standardNavigation.activeComponent);
		this.editPlacementsImageLibrary();
	}
};
